import { useQuery } from '@tanstack/react-query';
import { listDogs } from '@/api/entities/dogs';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';
import { useCognitoAuth } from '@/hooks/useCognitoAuth';

type ListDogsParams = {
  category?: string;
  sex?: string;
};

type QueryFnType = typeof listDogs;

type UseDogsOptions = {
  queryParams?: ListDogsParams;
  config?: QueryConfig<QueryFnType>;
};

export const useDogs = ({ queryParams, config }: UseDogsOptions = {}) => {
  const { getAccessToken } = useCognitoAuth();

  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['dogs', queryParams?.category, queryParams?.sex].filter(
      (value) => value !== undefined,
    ),
    queryFn: () => listDogs(queryParams, getAccessToken),
  });
};
